<div container>
  <ui-error [state]="loadState"></ui-error>

  <form [formGroup]="form" *visible="loadState.isCompleted" (submit)="saveAsync()" autocomplete="off">
    <div class="table-responsive mat-elevation-z2" *ngIf="!appLayout.isMobile">
      <table
        mat-table
        [dataSource]="dataSource"
        formArrayName="highSchools"
        [ui-column-width]="[270, 150, 150, 100, 100, 72]"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef i18n>שם התיכון</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <high-school-field
              [label]="highSchoolNameLabel.text"
              floatLabel="never"
              formControlName="name"
              appearance="legacy"
            >
            </high-school-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef i18n>ארץ</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <country-field formControlName="country" [label]="countryLabel.text" floatLabel="never" appearance="legacy">
            </country-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef i18n>עיר</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <city-field formControlName="city" [label]="cityLabel.text" floatLabel="never" appearance="legacy">
            </city-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="start-year">
          <th mat-header-cell *matHeaderCellDef i18n>שנת התחלה</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never">
              <input
                matInput
                type="number"
                formControlName="startYear"
                i18n-placeholder
                placeholder="שנת התחלה"
                (click)="addEmptyRow()"
                [max]="maxStartYear"
                required
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="end-year">
          <th mat-header-cell *matHeaderCellDef i18n>שנת סיום</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never">
              <input
                type="number"
                matInput
                formControlName="endYear"
                i18n-placeholder
                [max]="maxEndYear"
                placeholder="שנת סיום"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <button
              mat-icon-button
              type="button"
              [matTooltip]="deleteButtonTooltip.text"
              (click)="removeHighSchool(index)"
              [disabled]="!canRemoveHighSchool(row)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; let i = index; columns: displayColumns"></tr>
      </table>
    </div>

    <div *ngIf="appLayout.isMobile" formArrayName="highSchools">
      <ng-template #highSchoolEditor let-row let-i="index">
        <registration-entry-editor-shell
          [formGroupName]="i"
          [mode]="rowsEditor.isAddingRow(row) ? 'add' : 'edit'"
          [addTitle]="addHighSchoolTitle.text"
          [editTitle]="editHighSchoolTitle.text"
          [invalid]="rowsEditor.invalid"
          [invalidBody]="highSchoolInvalidBody.text"
          [cancelTooltip]="cancelTooltip.text"
          (cancel)="rowsEditor.cancel(row)"
          (save)="rowsEditor.save(row)"
        >
          <high-school-field appearance="fill" formControlName="name" [label]="highSchoolFieldLabel.text">
          </high-school-field>

          <country-field appearance="fill" formControlName="country" [label]="countryFieldLabel.text"> </country-field>

          <city-field appearance="fill" formControlName="city" [label]="cityFieldLabel.text"> </city-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>שנת התחלה</mat-label>
            <input matInput type="number" formControlName="startYear" [max]="maxStartYear" required />
            <mat-error *ngIf="row | hasError: 'startYear'" i18n>שדה חובה</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>שנת סיום</mat-label>
            <input matInput type="number" formControlName="endYear" [max]="maxEndYear" />
          </mat-form-field>
        </registration-entry-editor-shell>
      </ng-template>

      <ng-template #highSchoolCard let-row let-i="index">
        <registration-entry-card
          [title]="row.value.name"
          [meta]="rowCityCountry(row)"
          [footerStartOnly]="true"
          [editTooltip]="editTooltip.text"
          [deleteTooltip]="deleteButtonTooltip.text"
          [canDelete]="canRemoveHighSchool(row)"
          (edit)="rowsEditor.startEdit(row)"
          (delete)="removeHighSchool(i)"
        >
          <span footerBadge *ngIf="rowYearRange(row)" class="registration-entry-card__badge">{{
            rowYearRange(row)
          }}</span>
        </registration-entry-card>
      </ng-template>

      <registration-entry-list
        [rows]="rows"
        [editor]="rowsEditor"
        [addLabel]="addHighSchoolTitle.text"
        [editorTemplate]="highSchoolEditor"
        [cardTemplate]="highSchoolCard"
      >
      </registration-entry-list>
    </div>

    <ui-alert type="warning" *visible="showError && errorList.length > 0">
      <div ui-header i18n>לא ניתן לשמור מכיון שאחד או יותר מהפרטים שגויים או חסרים</div>

      <ul ui-body>
        <ng-container *ngFor="let error of errorList">
          <li *ngIf="error == 'startYear-required'" i18n>חובה להזין שנת התחלה</li>
          <li *ngIf="error == 'startYear-max'" i18n>שנת התחלה לא יכולה להיות גדולה משנה שעברה</li>
          <li *ngIf="error == 'startYear-pattern'" i18n>שנת התחלה לא בפורמט תקין</li>
          <li *ngIf="error == 'endYear-min'" i18n>שנת סיום לא יכולה להיות קטנה משנת התחלה</li>
          <li *ngIf="error == 'endYear-max'" i18n>שנת סיום לא יכולה להיות גדולה מהשנה הנוכחית</li>
        </ng-container>
      </ul>
    </ui-alert>

    <ui-error [state]="saveState"></ui-error>

    <ui-progress-button color="primary" [state]="saveState" i18n>
      {saveState.value, select, inProcess {שומר נתונים} other {שמור והמשך}}
    </ui-progress-button>
  </form>
</div>

<term #deleteButtonTooltip i18n>
  {gender, select, male {מחק} female {מחקי}}
  שורה
</term>

<term #editTooltip i18n>
  {gender, select, male {ערוך} female {ערכי}}
</term>

<term #cancelTooltip i18n>ביטול</term>

<term #highSchoolNameLabel i18n>
  {gender, select, male {הזן} female {הזיני}}
  שם תיכון
</term>

<term #countryLabel i18n>
  {gender, select, male {בחר} female {בחרי}}
  ארץ
</term>

<term #cityLabel i18n>
  {gender, select, male {בחר} female {בחרי}}
  עיר
</term>

<term #highSchoolFieldLabel i18n>שם התיכון</term>

<term #countryFieldLabel i18n>ארץ</term>

<term #cityFieldLabel i18n>עיר</term>

<term #addHighSchoolTitle i18n>הוספת תיכון</term>

<term #editHighSchoolTitle i18n>עריכת תיכון</term>

<term #highSchoolInvalidBody i18n>חובה להזין שם תיכון ושנת התחלה</term>
